/* Cravinbyandy — Menu cards mobile peek-carousel arrows.
   Scrolls the native scroll-snap track (mirrors locations-slider.js). Desktop shows the
   4-up grid, where the arrows are hidden by CSS, so this is a no-op there. */
(function () {
  function initCarousel(section) {
    var track = section.querySelector('[data-track]');
    if (!track || track.dataset.cInit) return;
    track.dataset.cInit = '1';

    function step(dir) {
      var card = track.querySelector('.menucards__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 22;
      var amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    var prev = section.querySelector('[data-prev]');
    var next = section.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function initAll() {
    document.querySelectorAll('[data-menucards]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
